import {
  messages as closeModalMessages,
  barcodeContent as closeModalBarcode,
  hotkey as closeModalHotkey,
} from '../../../../../../../components/hotkeys/close-modal';
import {
  messages as listHotkeysMessages,
  barcodeContent as listHotkeysBarcode,
  hotkey as listHotkeysHotkey,
} from '../../../../../../../components/hotkeys/list-hotkeys';
import {
  messages as goToNextODMessages,
  barcodeContent as goToNextODBarcode,
  hotkey as goToNextODHotkey,
} from '../../../../../../../components/hotkeys/go-to-next-modal';
import {
  messages as goToPreviousODMessages,
  barcodeContent as goToPreviousODBarcode,
  hotkey as goToPreviousODHotkey,
} from '../../../../../../../components/hotkeys/go-to-previous-modal';
import barcodeMessages from '../../../../../../../components/hotkeys/hotkeys-modal/messages';
import {
  barcodeContent as goToNextRecordBarcode,
  hotkey as goToNextRecordHotkey,
} from '../../../../../../../components/hotkeys/go-to-next-record';
import {
  barcodeContent as goToPreviousRecordBarcode,
  hotkey as goToPreviousRecordHotkey,
} from '../../../../../../../components/hotkeys/go-to-previous-record';
import {
  barcodeContent as openScanToViewBarcode,
  hotkey as openScanToViewHotkey,
} from '../../../../../../../components/hotkeys/open-orders-scan-to-search-modal';

export default [
  {
    barcodeContent: closeModalBarcode,
    intlFormattedName: closeModalMessages.name,
    hotkey: closeModalHotkey,
  },
  {
    barcodeContent: listHotkeysBarcode,
    intlFormattedName: listHotkeysMessages.name,
    hotkey: listHotkeysHotkey,
  },
  {
    barcodeContent: goToNextODBarcode,
    intlFormattedName: goToNextODMessages.name,
    hotkey: goToNextODHotkey,
  },
  {
    barcodeContent: goToPreviousODBarcode,
    intlFormattedName: goToPreviousODMessages.name,
    hotkey: goToPreviousODHotkey,
  },
  {
    barcodeContent: goToNextRecordBarcode,
    intlFormattedName: barcodeMessages.moveToNextRow,
    hotkey: goToNextRecordHotkey,
  },
  {
    barcodeContent: goToPreviousRecordBarcode,
    intlFormattedName: barcodeMessages.moveToPreviousRow,
    hotkey: goToPreviousRecordHotkey,
  },
  {
    barcodeContent: openScanToViewBarcode,
    intlFormattedName: barcodeMessages.openScanToSearch,
    hotkey: openScanToViewHotkey,
  },
];
